import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const VideoPlayer = ({ holding }) => {
  const [isLandscape, setIsLandscape] = useState(true);
  const [assetError, setAssetError] = useState(false);
  const [posterLoaded, setPosterLoaded] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  console.log("VideoPlayer holding: ", holding);

  useEffect(() => {
    // Attempt to load the poster image
    const img = new Image();
    img.src = `https://swayer.blob.core.windows.net/${holding.artworkId}-pub/thumbnail_master.png`;
    img.onload = () => {
      setPosterLoaded(true);
    };
  }, [holding]);

  const handleMetadataLoaded = (event) => {
    const videoElement = event.target;
    const { videoWidth, videoHeight } = videoElement;
    setIsLandscape(videoWidth >= videoHeight);
  };

  const handleVideoError = () => {
    setAssetError(true);
  };

  const getVideoWidth = () => {
    if (isMobile && !isLandscape) {
      return "100%";
    } else if (isLandscape) {
      return "100%";
    } else {
      return "30%";
    }
  };

  return (
    <Box
      sx={{
        mb: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {assetError && (
        <Typography variant="body2" sx={{ color: "#888" }}>
          This video could not be loaded.
        </Typography>
      )}
      {posterLoaded && !assetError && (
        <video
          controls
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          onLoadedMetadata={handleMetadataLoaded}
          onError={handleVideoError}
          poster={`https://swayer.blob.core.windows.net/${holding.artworkId}-pub/thumbnail_master.png`}
          style={{
            width: getVideoWidth(),
            borderRadius: "25px",
            transition: "width 0.3s ease-in-out",
          }}
        >
          <source
            src={`https://swayer.blob.core.windows.net/${holding.artworkId}-pub/_main.mp4`}
            type="video/mp4"
            onError={handleVideoError}
          />
          Your browser does not support the video tag.
        </video>
      )}
    </Box>
  );
};

export default VideoPlayer;
